export default "__VITE_ASSET__ByVkn_iK__"